import PortalVue from 'portal-vue'
import { createPinia } from 'pinia'
import biliMirror from '@bilibili/bili-mirror'
import router from '../router'
import { usePlugin } from '@/plugins'
import { useMixin } from '@/mixin'
import { useDirective } from '@/directive'
import { installComponents } from '@/components'
const pinia = createPinia()

export const setCommonApp = app => {
  app.config.globalProperties.$router = router
  app.use(router)
  app.use(PortalVue)

  if (process.env.NODE_ENV !== 'development') {
    app.use(biliMirror, {
      origin: 'sycpb',
      module: 'huahuo-account',
      pbOptions: {
        autoPv: false,
        logLevel: process.env.NODE_ENV === 'development' ? 1 : 0,
        batch: true
      }
    })
  }
  app.use(pinia)

  usePlugin(app)
  useMixin(app)
  installComponents(app)
  useDirective(app)
}
